// The admin heatmap viewer embeds storefront pages in an iframe with
// `?pa_heatmap=1`. In that mode we suppress the consent banner and the
// trackers, and run the scroll-sync bridge instead.
export const HEATMAP_PREVIEW_PARAM = "pa_heatmap"

export function isHeatmapPreview(): boolean {
  if (typeof window === "undefined") return false
  try {
    return (
      new URLSearchParams(window.location.search).get(
        HEATMAP_PREVIEW_PARAM
      ) === "1"
    )
  } catch {
    return false
  }
}
